import { routes } from 'commons/constants/routes'
import { Link, SymbolBadge, TableActions, TableActionsItem, Tooltip } from 'ui/components'
import { DateTime } from 'ui/components/DateTime'
import { IconName } from 'ui/components/Icon'
import { TableColumn } from 'ui/components/Table'
import { CRBConnections } from '~bank-crb-monitor/types'

import { CRBStatus } from '../CRBStatus'

import { s } from './styles'

enum LicenseView {
  VIEW = 'view',
  EDIT = 'edit'
}

export const columns = ({
  onOpenHistory,
  onLicenseSelect
}: {
  onOpenHistory: (id: number) => void
  onLicenseSelect: (view: LicenseView, licenseId: number, crbId: number) => void
}): TableColumn<CRBConnections>[] => [
  {
    title: 'Relationship',
    align: 'left',
    sortable: true,
    key: 'relationship',
    render: ({ relationship, relationshipId }) => (
      <Link to={routes.bank.relationships.details} params={{ id: relationshipId.toString() }}>
        {relationship}
      </Link>
    )
  },
  {
    title: 'Orbit License',
    align: 'left',
    key: 'licenseName',
    render: ({ licenseId, licenseName, licenseNumber, showLicenseAlerted }) => (
      <s.Status>
        {showLicenseAlerted && (
          <Tooltip content={showLicenseAlerted} id={`${licenseId}`} type="dark" event="hover">
            <div>
              <SymbolBadge color="warning" icon={IconName.CHECK_ROUND} />
            </div>
          </Tooltip>
        )}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Link to="/licenses/$licenseId" params={{ licenseId: licenseId.toString() }}>
            {licenseNumber}
          </Link>
          {licenseName}
        </div>
      </s.Status>
    )
  },
  {
    title: 'Connection Status',
    align: 'left',
    key: 'connectionStatus',
    sortable: true,
    render: ({ disconnected, connectionStatus, licenseId, id }) => (
      <s.Status onClick={() => onLicenseSelect(!disconnected ? LicenseView.VIEW : LicenseView.EDIT, licenseId, id)}>
        {disconnected && <SymbolBadge color="error" icon={IconName.CROSS_ROUND} />}
        {connectionStatus}
      </s.Status>
    )
  },
  {
    title: 'CRBM License Status',
    align: 'left',
    key: 'crbmLicenseStatus',
    sortable: true,
    render: ({ showExternalStatus, showExternalStatusMark, licenseId, disconnected, id }) => (
      <s.Container onClick={() => onLicenseSelect(!disconnected ? LicenseView.VIEW : LicenseView.EDIT, licenseId, id)}>
        <CRBStatus icon={showExternalStatusMark} status={showExternalStatus || '--'} />
      </s.Container>
    )
  },
  {
    title: 'Last Check',
    align: 'left',
    render: ({ showLastCheckedAt }) => <DateTime date={showLastCheckedAt} withTime />
  },
  {
    title: 'Actions',
    align: 'center',
    width: '50px',
    render: ({ id, licenseId, disconnected }) => (
      <>
        <div data-sidepanel={licenseId} />
        <TableActions
          items={
            [
              !disconnected
                ? {
                    type: 'details',
                    onClick: () => onLicenseSelect(LicenseView.VIEW, licenseId, id)
                  }
                : null,
              {
                type: 'edit',
                onClick: () => onLicenseSelect(LicenseView.EDIT, licenseId, id)
              },
              {
                type: 'history',
                onClick: () => onOpenHistory(id)
              }
            ].filter(Boolean) as TableActionsItem[]
          }
        />
      </>
    )
  }
]
